module.exports = __webpack_public_path__ + "static/media/fr_graphic_permacool.bbb297dc.png";